import React from 'react';
import { observer } from 'mobx-react';
import { Catcher, LoadingApiByIds } from '../../';
import { HorizontalRevenueChart } from './';
import { useDashboardCardSetRevenueChart, useProfile, useRouterStore } from '../../../hooks';
import { tI, tP } from '../../../translate';
import Styles from '../m_dashboarStyles.less';

export const CardSetRevenue: React.FC = observer(() => {
    const data = useDashboardCardSetRevenueChart();
    const routerStore = useRouterStore();
    const { isCompanyTypeIdMNOHost } = useProfile();
    const title = `${tP('Top Card Sets')} ${tI(isCompanyTypeIdMNOHost ? 'by Revenue' : 'by Cost/Revenue')}`;
    const goToCardList = (): void => {
        routerStore.goTo('CardSetsList');
    };

    const titleLink = (): JSX.Element => (
        <a onClick={goToCardList} href={`/card_sets`}>
            {title}
        </a>
    );

    const goToCardSet = (id: string): void => {
        routerStore.goTo('CardSet', { params: { id } });
    };

    return (
        <Catcher>
            <LoadingApiByIds idSpinners={['GET_REVENUE_CARD_SET_LIST']} />
            <div className={Styles.chart}>
                <HorizontalRevenueChart
                    sourceData={data}
                    title={title}
                    titleLink={titleLink()}
                    onSelectRow={goToCardSet}
                />
            </div>
        </Catcher>
    );
});
